module.exports = __webpack_public_path__ + "media/images/iconTrendDown__errorRed-5ce31bbf1495554ebcd90ed281c96803.png";